




import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: {
    AdminIframe,
  },
})
export default class MemberSearchIframe extends Vue {
  private get remoteSrc() {
    const queryObject = { ...this.$route.query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();

    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/popup/search-member?' + queryString;
  }

  private receiveMessage({ data }: MessageEvent) {
    if (data?.type === 'SELECTED_MEMBER') {
      window.opener.postMessage(data);
      window.close();
    }
  }

  mounted() {
    window.addEventListener('message', this.receiveMessage);
  }
  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
  }
}
